import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getSkladonMappingDetailFetchSuccess,
    getSkladonMappingDetailFetchFailure,
    createSkladonMappingDetailFetchSuccess,
    createSkladonMappingDetailFetchFailure,
    updateSkladonMappingDetailFetchSuccess,
    updateSkladonMappingDetailFetchFailure,
    deleteSkladonMappingFetchSuccess,
    deleteSkladonMappingFetchFailure,
} from './reducer';
import { SkladonMappingDetailResType } from 'src/types/skladonMappingDetail';
import { SkladonMappingType } from 'src/types/skladonMapping';
import translate from '@translate';

const getSkladonMappingDetailFetchRequest = async (idSkladonMapping: string) => {
    const res = await api('get', `api/secure/skladon-mapping/${idSkladonMapping}`);
    return res.data;
};

function* getSkladonMappingDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: SkladonMappingDetailResType = yield call((): any =>
            getSkladonMappingDetailFetchRequest(action.payload)
        );
        yield put(getSkladonMappingDetailFetchSuccess(response));
    } catch (error) {
        yield put(getSkladonMappingDetailFetchFailure({ error }));
    }
}

export function* getSkladonMappingDetailFetchWatch() {
    yield takeEvery('skladonMappingDetail/getSkladonMappingDetailFetch', getSkladonMappingDetailFetch);
}

const createSkladonMappingDetailFetchRequest = async (data: SkladonMappingType) => {
    const res = await api('post', 'api/secure/skladon-mapping', data);
    return res.data;
};

function* createSkladonMappingDetailFetch(action: { type: string; payload: SkladonMappingType }) {
    try {
        const response: SkladonMappingDetailResType = yield call((): any =>
            createSkladonMappingDetailFetchRequest(action.payload)
        );
        yield put(
            createSkladonMappingDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('skladonMapping.message.skladonMappingCreated') },
            })
        );
    } catch (error) {
        console.error('Error creating skladon mapping:', error);
        yield put(createSkladonMappingDetailFetchFailure({ error }));
    }
}

export function* createSkladonMappingDetailFetchWatch() {
    yield takeEvery('skladonMappingDetail/createSkladonMappingDetailFetch', createSkladonMappingDetailFetch);
}

const updateSkladonMappingDetailFetchRequest = async (params: {
    idSkladonMapping: string;
    data: SkladonMappingType;
}) => {
    const res = await api('put', `api/secure/skladon-mapping/${params.idSkladonMapping}`, params.data);
    return res.data;
};

function* updateSkladonMappingDetailFetch(action: {
    type: string;
    payload: { idSkladonMapping: string; data: SkladonMappingType };
}) {
    try {
        const response: SkladonMappingDetailResType = yield call((): any =>
            updateSkladonMappingDetailFetchRequest(action.payload)
        );
        yield put(
            updateSkladonMappingDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('skladonMapping.message.skladonMappingUpdate') },
            })
        );
    } catch (error) {
        console.error('Error updating skladon mapping:', error);
        yield put(updateSkladonMappingDetailFetchFailure({ error }));
    }
}

export function* updateSkladonMappingDetailFetchWatch() {
    yield takeEvery('skladonMappingDetail/updateSkladonMappingDetailFetch', updateSkladonMappingDetailFetch);
}

const deleteSkladonMappingFetchRequest = async (idSkladonMapping: string) => {
    const res = await api('delete', `api/secure/skladon-mapping/${idSkladonMapping}`);
    return res.data;
};

function* deleteSkladonMappingFetch(action: { type: string; payload: string }) {
    try {
        const response: SkladonMappingDetailResType = yield call((): any =>
            deleteSkladonMappingFetchRequest(action.payload)
        );
        yield put(
            deleteSkladonMappingFetchSuccess({
                ...response,
                messageSuccess: { title: translate('skladonMapping.message.skladonMappingDeleted') },
            })
        );
    } catch (error) {
        console.error('Error deleting skladon mapping:', error);
        yield put(deleteSkladonMappingFetchFailure({ error }));
    }
}

export function* deleteSkladonMappingFetchWatch() {
    yield takeEvery('skladonMappingDetail/deleteSkladonMappingFetch', deleteSkladonMappingFetch);
}
